
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/workspace-management/approval-flows",
      function () {
        return require("private-next-pages/workspace-management/approval-flows.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/workspace-management/approval-flows"])
      });
    }
  